module.exports = __webpack_public_path__ + "img/Rectangle1.72f5b39.png";